<template>        
    <div id="appRoot">        
        <template v-if="!$route.meta.public">
            <v-app>                                    
                <app-left-drawer class="app-left-drawer"></app-left-drawer>         
                <app-toolbar class="app--toolbar"></app-toolbar>                
                <app-content class="app--content"></app-content>                        
                <app-fab></app-fab>
                <widget-fetch></widget-fetch>                     
            </v-app>            
        </template>
        <template v-else>
            <v-app>
                <transition>
                    <keep-alive>
                        <v-slide-y-transition mode="out-in">
                            <router-view></router-view>
                        </v-slide-y-transition>
                    </keep-alive>
                </transition>
            </v-app>
        </template>
        <app-snackbar></app-snackbar>        
    </div>        
</template>

<script>
import AppFab from './components/app/Fab';
import AppToolbar from './components/app/Toolbar';
import AppLeftDrawer from './components/app/LeftDrawer';
import AppContent from './components/app/Content';
import AppSnackbar from './components/app/Snackbar';
import WidgetFetch from './components/widgets/Fetch';
import AppEvents from  '@/event';


//import Device from '@/util/models/Device';
import User   from '@/util/models/User';
//import Synch from '@/util/models/Synch';


export default {
    name: 'App',
    components: {        
        AppFab,   
        AppToolbar,
        AppLeftDrawer,
        AppContent,
        AppSnackbar,
        WidgetFetch,
    },
    data() {
        return {            
            title: 'Vuetify.js',
            synch: false,
            login: false,            
        }
    },
    created () {
        window.getApp = this;
        if(!User.isLogin()){            
            this.$router.replace({ path: '/login' });
        }

        AppEvents.forEach(item => {
            this.$on(item.name, item.callback);
        });                                 
    },   
    watch:{
        $route (to, from){   
            let attr = User.info().attr;
            document.title = attr ? attr.name : this.$config.title;                       
        },
    }    
    
}
</script>
<style>
    .v-content{
        min-height: 100%;
        padding-bottom:200px;
    }
    .v-footer{
        position:absolute; bottom:0px; width:100%; height: auto; bottom: 0px; margin-top: 100px;
    } 
    .swal2-container, #appRoot {
        font-family: 'Roboto', sans-serif;
    }
    #swal2-content {
        font-family: arial
    }    
    .v-tooltip a{
        width:40px;
        height:42px;                
        top:0px;
        left:0px;
    }   
    .v-tooltip button{
        width:40px;
        height:42px;                
        top:0px;
        left:0px;
    }
    button .v-tooltip i{
        margin-top:10px
    }
    a{
        text-decoration: none;
    }
    .tabs-scroll{
        height: calc(100vh - 145px);      
        overflow-y: auto;            
    }
    .dapil-scroll{
        height: calc(100vh - 225px);      
        overflow-y: auto;            
    }
    .branch-scroll{
        height: calc(100vh - 161px);      
        overflow-y: auto;            
    }
    .bottom-scroll{
        height: calc(100vh - 64px);      
        overflow-y: auto;      
        z-index:2;
    }
    .live-scroll{
        height: calc(100vh - 64px);      
        overflow-y: auto;              
    }
    @media only screen and (max-width: 1000px) and (min-width:500px) {
        .dapil-scroll{height: calc(100vh - 180px);}
        .tabs-scroll{height: calc(100vh - 130px);}
        .branch-scroll{height: calc(100vh - 133px);}
        .bottom-scroll{height: calc(100vh - 50px);}
    }
    @media only screen and (max-width: 500px) {
        .dapil-scroll{height: calc(100vh - 205px);}
        .tabs-scroll{height: calc(100vh - 140px);}
        .branch-scroll{height: calc(100vh - 148px);}
        .bottom-scroll{height: calc(100vh - 57px);}
    }
     .tabular table.v-table tbody td:first-child, .tabular table.v-table tbody td:not(:first-child), .tabular table.v-table tfoot td:first-child, .tabular table.v-table tfoot td:not(:first-child), .tabular table.v-table tbody th:first-child, .tabular table.v-table tbody th:not(:first-child), .tabular table.v-table thead td:first-child, .tabular table.v-table thead td:not(:first-child), .tabular table.v-table thead th:first-child, .tabular table.v-table thead th:not(:first-child) {
        padding: 0 4px;
    }
    .tabular table.v-table tbody td:first-child, .tabular table.v-table thead th:first-child, .tabular table.v-table tfoot td:first-child{
        padding: 0 4px 0 12px;
    }
    .nopadding table.v-table tbody td:first-child, .nopadding table.v-table thead th:first-child, .nopadding table.v-table tfoot td:first-child{
        padding: 0px;
    }
    .cursor{
      cursor: pointer;
    }
    .list-select{border-left: 3px solid #11E611;}
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
      -webkit-appearance: none; 
      margin: 0; 
    }
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>
